<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name:'Invoices'
        
    }
</script>

<style lang="scss" scoped>

</style>